import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import {
  DSButton,
  DSInput,
} from "@components/design-system/molecules";
import React from "react";
import { Controller, useForm } from "react-hook-form";

import Twemoji from "../../Twemoji";
import { defaultErrorHandler } from "../../utils/operationTracking";
import { alert } from "../common/Alert";

const CONFIRM_USER_MUTATION = gql`
  mutation sendForgotPasswordEmail($email: String) {
    sendForgotPasswordEmail(email: $email) {
      ok
    }
  }
`;

export default function ForgotPassword() {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [sendForgotPasswordEmail] = useMutation(
    CONFIRM_USER_MUTATION,
  );

  function submitEmail({ email }) {
    sendForgotPasswordEmail({
      variables: {
        email,
      },
    })
      .then((response) => {
        const { ok } = response.data.sendForgotPasswordEmail;

        if (ok) {
          alert(
            "success",
            "If an account with this email exists, we've sent a password reset link to it!",
          );
        }
      })
      .catch(defaultErrorHandler);
  }

  return (
    <form
      onSubmit={handleSubmit(submitEmail)}
      className="flex-col items-center justify-center sm:px-6 lg:px-8"
    >
      <div className="space-y-8">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-primary">
          <Twemoji emoji="🤬" /> Forgotten Passwords...
        </h2>
        <h6 className="text-center text-primary">
          Don&apos;t Worry! Enter your Scribenote account&apos;s email
          below and we&apos;ll send you a link to continue.
        </h6>
        <div className="flex flex-col max-w-2xl mx-auto">
          <Controller
            control={control}
            name="email"
            rules={{ required: true, pattern: /^\S+@\S+$/i }}
            render={({ field }) => (
              <DSInput
                placeholder={"Type your email here"}
                dataTestId="forgot-password-email"
                {...field}
              />
            )}
          />
          {errors.email && (
            <p className="text-danger text-xs text-center mt-1">
              Please enter your email address.
            </p>
          )}
          <div className="m-8 flex justify-center">
            <DSButton
              type="submit"
              variant="primary"
              size="lg"
              dataTestId="forgot-password-submit"
            >
              Submit
            </DSButton>
          </div>
        </div>
      </div>
    </form>
  );
}
